import React, {useEffect} from 'react';

// @material-ui/core components
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';

// core components
import Sidebar from '../components/Sidebar/Sidebar'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import SimulationBar from '../components/SimulationBar/SimulationBar';
import Hidden from '@material-ui/core/Hidden';

// styles
import useStyles from '../../assets/styles/jss/layout/mainStyle'
import clsx from 'clsx';

// redux
import { connect } from 'react-redux';
import * as tourInitialActions from '../../redux/actions/tourInitialActions';

import SidebarMenu from './components/SidebarMenu';
import AlertTemsAndConditions from '../components/AlertTemsAndConditions/AlertTemsAndConditions';
import BottomMenu from '../components/BottomMenu/BottomMenu';
import Maintenance from "../../pages/HttpErrors/Maintenance";
import {useFeatureIsOn, useFeatureValue} from "@growthbook/growthbook-react";
import {isMantenance} from "../../shared/constants/maintenance";


const Main = (props) => {
    const { children, showTour, isLogged } = props;
    const classes = useStyles({isLogged});
    const [open, setOpen] = React.useState(false);
    const [showMaintenance, setShowMaintenance] = React.useState(false)

    const maintenanceIsOn = useFeatureIsOn('maintenance-web')
    const maintenanceValue =  useFeatureValue('maintenance-web')

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(maintenanceIsOn && maintenanceValue?.is_support){
            setShowMaintenance(isMantenance(maintenanceValue))
        }
    })

    return (
        <div className={classes.simulation_bar}>
            <AlertTemsAndConditions />
            <SimulationBar />
            <div className={classes.root}>
                <CssBaseline />
                {/* <TourInicial /> */}
                <Navbar
                    isLogged={isLogged}
                    position="fixed" {...children.props}
                    className={clsx(classes.appBar, { [classes.appBarShift]: open })}
                    handleDrawerToggle={handleDrawerOpen}
                />
                <Sidebar open={open} onClose={handleDrawerClose} {...children.props} isLogged={isLogged}>
                    <SidebarMenu />
                </Sidebar>
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: open,
                    })}
                >
                    <div className={`${classes.drawerHeader} no-print`} />
                    <Container className={classes.container}>
                        {showMaintenance ? <Maintenance {...maintenanceValue} /> : children }
                    </Container>
                </main>
                <BottomMenu />
            </div>
                <Hidden smDown>
                    <Footer isLogged={isLogged}/>
                </Hidden>
        </div>
    );
};

const mapStateToProps = ({ tourInitialReducer }) => ({
    showTour: tourInitialReducer.showTour
});

const mapDispatchToProps = { ...tourInitialActions };

export default connect(mapStateToProps, mapDispatchToProps)(Main);
